import React, { useEffect, useState } from "react";
import { useApolloClient } from "@apollo/react-hooks";
import { GET_STEP_DETAILS } from "./getStepDetail";
import CommonProcessRender from "./utils/CommonProcessRender";
import GettingStepDetails from "./utils/GettingStepDetails";

const PoweredMFG = ({ StepID }) => {
  const client = useApolloClient();
  const [stepDetails, setStepDetails] = useState([]);

  useEffect(() => {
    const GetClientSteps = () => {
      client
        .query({
          query: GET_STEP_DETAILS,
          variables: { step_id: StepID },
        })
        .then(({ data }) => {

          setStepDetails(data.getFieldsByStepId);
        })
        .catch((error) => {
          console.log("error", error);
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
    };

    GetClientSteps();


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepDetails]);

  const content = <GettingStepDetails stepDetails={stepDetails} />;

  // Component Returning Content...
  return <>{content}</>;
};

export default PoweredMFG;
